/*
 * Copyright (c) 2024-2025 Nodals AI Ltd
 * All rights reserved.
 */

class EventObject<T> {
  constructor(
    public target: any,
    public data: T
  ) {}
}

class EventDispatcher<T extends Record<string, any>> {
  private listeners: { [K in keyof T]?: Array<(event: EventObject<T[K]>) => void> } = {};

  on<K extends keyof T>(event: K, listener: (event: EventObject<T[K]>) => void): void {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event]!.push(listener);
  }

  off<K extends keyof T>(event: K, listener: (event: EventObject<T[K]>) => void): void {
    if (!this.listeners[event]) return;
    this.listeners[event] = this.listeners[event]!.filter((l) => l !== listener);
  }

  dispatch<K extends keyof T>(event: K, data?: T[K]): void {
    if (!this.listeners[event]) return;
    const eventObject = new EventObject(this, data as T[K]);
    this.listeners[event]!.forEach((listener) => listener(eventObject));
  }
}

export { EventDispatcher, EventObject };
